import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { LogsService } from 'src/app/shared/services/logs.service';

@Injectable({
  providedIn: 'root',
})
export class redirectGuard implements CanActivate {
  private pageReloaded!: boolean;

  constructor(private router: Router, private connection: ConnectionService, private cacheService: CacheService, private logsService: LogsService) {
    this.connection.redirect$.subscribe((data) =>{
      this.pageReloaded = data;
    })
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let returnRedirect!: boolean

    if(this.pageReloaded)
    {
      this.connection.updateRedirect(false)
      let nameCompany = this.cacheService.getItemLocal('nameCompany');

      //Resgata o cache do QrCode e do Balcão
      let qrCode = this.cacheService.getItemLocal('qrCode_key');
      let counter = this.cacheService.getItemLocal('counter_key');

      //Verifica se o cache do QrCode expirou
      if(qrCode && !this.cacheService.getItemLocalTimeout('qrCode_key'))
      {
        this.router.navigate(['/Authentication']);
        this.logsService.sendLogs("Qr Code Mesa Expirado", "warn");
        return false;
      }

      //Verifica se o cache do Balcão expirou
      if(counter && !this.cacheService.getItemLocalTimeout('counter_key'))
      {
        this.router.navigate(['/Authentication']);
        this.logsService.sendLogs("Qr Code Balcão Expirado", "warn");
        return false;
      }

      //Redireciona para a página de Mesa
      if(qrCode != null)
      {
        if(nameCompany != '')
        {
          this.router.navigate([nameCompany, 'P']);
        }
        else{
          this.router.navigate(['']);
        }

        this.logsService.sendLogs("Redirecionamento para Mesa", "sucess", qrCode);

      }
      //Redireciona para a página de Balcão
      else if(counter != null)
      {
        if(nameCompany != '')
        {
          this.router.navigate([nameCompany, 'B']);
        }
        else{
          this.router.navigate(['']);
        }

        this.logsService.sendLogs("Redirecionamento para Balcão", "sucess", counter);
      }
      //Redireciona para a página Delivery
      else{

        if(nameCompany != '')
        {
          this.router.navigate([nameCompany]);
        }
        else
        {
          this.router.navigate(['']);
        }

        this.logsService.sendLogs("Redirecionamento para Delivery", "sucess", nameCompany);

      }

    }
    else if(this.pageReloaded)
    {
      returnRedirect = true
    }

    return returnRedirect

  }
}

